import classNames from 'classnames';

import { QueueItem } from '@bpm-web-app/utils';
import { MouseEventHandler } from 'react';
import { Album as DownloadAlbum } from '@bpm-web-app/download-api-sdk';
import { ThreeDotsSheetOptionsKeys, THREE_DOTS_SHEET_KEYS } from '../../three-dots-sheet/three-dots-sheet.context';
import styles from './quick-actions-column.module.css';

import AddToPlaylistIcon from '../../../../assets/icons/supreme/add-to-playlist.svg';
import ThreeDotsIcon from '../../../../assets/icons/supreme/three-dots.svg';
import AddToCrate from '../../../../assets/icons/add-to-crate.svg';

// openThreeDots is not a simple MouseEventHandler because some entry points
// (e.g., Add to Crate) need to open the sheet with a specific option preselected.
// The optional initialKey allows callers to control the sheet's initial state.
type OpenThreeDotsHandler = (e: React.MouseEvent<HTMLButtonElement>, initialKey?: ThreeDotsSheetOptionsKeys) => void;

interface QuickActionsColumnProps {
    media: QueueItem;
    openPlaylists: MouseEventHandler<HTMLButtonElement>;
    openThreeDots: OpenThreeDotsHandler;
    isVisible: boolean;
    downloadAlbum?: DownloadAlbum;
    addDownloadTrackToCrate?: (mediaId: number) => void;
}

export function QuickActionsColumn({ media, openThreeDots, openPlaylists, isVisible, downloadAlbum, addDownloadTrackToCrate }: QuickActionsColumnProps) {
    return (
        <div
            className={classNames(styles['quick-actions-column'], {
                [styles['quick-actions-column--visible']]: isVisible,
            })}
        >
            <button
                className={classNames(styles['quick-actions-column__button'], styles['quick-actions-column__button--tablet-up-only'], 'three-dots-button')}
                type="button"
                onClick={openPlaylists}
                aria-label="Add to Playlist"
                data-tip="Add to Playlist"
                data-tip-show
                data-delay-show="400"
            >
                <AddToPlaylistIcon />
            </button>

            <button
                className={classNames(styles['quick-actions-column__button'], styles['quick-actions-column__button--tablet-up-only'])}
                type="button"
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    // UX decision: if there is only one available version,
                    // skip opening the sheet and add it directly to the crate
                    if (downloadAlbum?.media?.length === 1 && addDownloadTrackToCrate) {
                        addDownloadTrackToCrate(downloadAlbum.media[0].id);
                    } else {
                        // if not open three dots preselected on add to crate option
                        openThreeDots(e, THREE_DOTS_SHEET_KEYS.ADD_TO_CRATE);
                    }
                }}
                aria-label="Add to Crate"
                data-tip="Add to Crate"
                data-tip-show
                data-delay-show="400"
            >
                <AddToCrate />
            </button>

            <button
                className={classNames(styles['quick-actions-column__button'], styles['quick-actions-column__button--three-dots'], 'three-dots-button')}
                type="button"
                aria-label="More"
                data-tip="Show More"
                data-tip-show
                data-delay-show="400"
                onClick={openThreeDots}
            >
                <ThreeDotsIcon />
            </button>
        </div>
    );
}
